import React from 'react'
import { Link, withRouter } from 'react-router-dom'
import {Layout, Menu, message, Spin} from 'antd';
import {LogoutOutlined} from "@ant-design/icons";
import { Icon } from '@ant-design/compatible';

import Menus from '../../infra/menus/Menus'
import {get} from "../../services/http/RevendaService"
import {getUser, isOrganization, isUpgasEmployee} from "../../services/UserService"
import './SideBar.scss'

const { Sider } = Layout

class SideBar extends React.Component {
  constructor(props) {
    super(props)

    const openKeys = localStorage.getItem('openKeys') ? JSON.parse(localStorage.getItem('openKeys')) : []
    const selectedKeys = localStorage.getItem('selectedKeys') ? JSON.parse(localStorage.getItem('selectedKeys')) : []

    this.state = {
      organizationResales: [],
      openKeys,
      selectedKeys
    }

    this.normalizeLocalStorageSelectedKeys()
  }

  componentDidMount() {
    if (isOrganization()) {
      this.getInstance = get(1, 10, null)
      this.getInstance.promise
        .then(dataSource => this.setState({ organizationResales: dataSource.items }))
        .catch(error => message.error(error.errorMessage))
    }
  }

  componentWillUnmount() {
    if (this.getInstance) {
      this.getInstance.cancel()
    }
  }

  normalizeLocalStorageSelectedKeys = () => {
    const selectedKeys = localStorage.getItem('selectedKeys')

    if (selectedKeys && !Array.isArray(JSON.parse(selectedKeys))) {
      localStorage.setItem('selectedKeys', JSON.stringify([selectedKeys]))
    }
  }

  changeSelectedKey = ({ key, notSelectable }) => {
    const isIncludedOnOpenKeys = this.state.openKeys.includes(key)

    if (!isIncludedOnOpenKeys) {
      this.setState({ openKeys: [] })
      localStorage.setItem('openKeys', JSON.stringify([]))
    }

    if (notSelectable) return;
    localStorage.setItem('selectedKeys', JSON.stringify([key]))
    this.setState({ selectedKeys: [key] })
  }

  changeMenuOpen = openKeys => {
    const latestOpenKey = openKeys.find(key => this.state.openKeys.indexOf(key) === -1);

    if (!latestOpenKey) this.setState({ openKeys: [] })

    localStorage.setItem('openKeys', JSON.stringify([latestOpenKey]))
    this.setState({ openKeys: [latestOpenKey] })
  }

  initialsUserName = () => {
    const userNameSplitted = getUser().name.split(" ")
    let initials = ""

    userNameSplitted.forEach(word => initials += word ? word[0].toUpperCase() : "")

    if (initials.length > 2) initials = initials.substring(0,2)
    if (initials.length == 1) initials = `${userNameSplitted[0][0].toUpperCase()}${userNameSplitted[0][1].toUpperCase()}`
    return initials;
  }

  render() {
    const { organizationResales, openKeys, selectedKeys, isMobile } = this.state
    const { isCollapsed, loading, employeeMenus } = this.props
    const menus = isUpgasEmployee()
      ? Menus(organizationResales).filter(({ menuEnum }) => employeeMenus.includes(menuEnum))
      : Menus(organizationResales)

    return (
      <Sider
        width={250}
        trigger={null}
        collapsible
        collapsed={isCollapsed}
      >
        {loading
          ? (
            <Spin className="sidebar-spin" size="large" />
          )
          : (
            <>
              <div className="logo" style={{display: "flex", justifyContent: "center" }}>
                <h2 style={{color:'white'}}>{isCollapsed ? this.initialsUserName() : getUser().name}</h2>
              </div>
              <Menu theme="light" mode="inline" openKeys={openKeys} selectedKeys={selectedKeys} onOpenChange={this.changeMenuOpen}>
                {menus
                  .map(menu => {
                    if (menu.childs.some(x => x)) {
                      return (
                        <Menu.SubMenu
                          key={menu.key}
                          title={
                            <React.Fragment>
                              <Icon style={{ fontSize: 20 }} type={menu.icon} />
                              <span>{menu.text}</span>
                            </React.Fragment>
                          }
                        >
                          {menu.childs.map(sub => <Menu.Item key={sub.key}>
                            <Link onClick={() => this.changeSelectedKey(menu)} to={sub.url}>
                              {sub.icon !== null && <Icon style={{ fontSize: 20 }} type={sub.icon} />}
                              <span>{sub.text}</span>
                            </Link>
                          </Menu.Item>)}
                        </Menu.SubMenu>
                      )
                    }

                    return !menu.propAction
                      ? (
                        <Menu.Item key={menu.key} disabled={menu.disabled}>
                          {menu.component
                            ? <menu.component menu={menu} onClick={() => this.changeSelectedKey(menu)} />
                            : <React.Fragment>
                              <Link onClick={() => this.changeSelectedKey(menu)} to={menu.url}>
                                <Icon style={{ fontSize: 20 }} type={menu.icon} />
                                <span>{menu.text}</span>
                              </Link>
                            </React.Fragment>
                          }
                        </Menu.Item>
                      )
                      : (
                        <Menu.Item onClick={() => this.changeSelectedKey(menu)} key={menu.key}>
                          <span onClick={() => this.props[menu.propAction]()} >
                            <Icon style={{ fontSize: 20 }} type={menu.icon} />
                            <span>{menu.text}</span>
                          </span>
                        </Menu.Item>
                      )
                  })
                }
                <Menu.Item onClick={() => this.props.logOut()}>
                  <LogoutOutlined style={{ fontSize: 20 }} />
                  <span>Sair</span>
                </Menu.Item>
              </Menu>
            </>
          )
        }
      </Sider>
    )
  }
}

export default withRouter(SideBar)
